@file:OptIn(ExperimentalJsExport::class)
package game

import org.reduxkotlin.createStore
import org.reduxkotlin.typedReducer

@JsExport
val gameStore = createStore(
    reducer = typedReducer<GameState, GameAction> { state, action ->
        gameReducer(state, action)
    },
    preloadedState = createInitialState()
)
